import React, { useEffect, useState } from "react";
import "./Dashboard.css";

const Dashboard = () => {
  const [loginLogs, setLoginLogs] = useState([]);
  const [registerLogs, setRegisterLogs] = useState([]);
  const [view, setView] = useState("login");

  useEffect(() => {
    const fetchLogs = () => {
      fetch("/dashboard", {
        credentials: "include",
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error ${response.status}`);
          }
          return response.json();
        })
        .then((data) => {
          setLoginLogs(data.loginLogs || []);
          setRegisterLogs(data.registerLogs || []);
        })
        .catch((error) => console.error("Error fetching data:", error));
    };

    fetchLogs();
  }, []);

  const formatTime = (isoString) => {
    const date = new Date(isoString);
    return date.toLocaleString("th-TH", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  };

  return (
    <div className="dashboard-container">
      <div className="dashboard-controls">
        <button
          className={`toggle-button ${view === "login" ? "active" : ""}`}
          onClick={() => setView("login")}
        >
          Show Login Logs
        </button>
        <button
          className={`toggle-button ${view === "register" ? "active" : ""}`}
          onClick={() => setView("register")}
        >
          Show Registration Logs
        </button>
      </div>

      <div className="dashboard-card-horizontal">
        {view === "login" && (
          <div className="logs-section-horizontal">
            <h2 className="logs-title">Login Logs</h2>
            <table className="logs-table">
              <thead className="logs-table-header">
                <tr>
                  <th className="logs-table-head">Email</th>
                  <th className="logs-table-head">Time</th>
                  <th className="logs-table-head">Status</th>
                </tr>
              </thead>
              <tbody>
                {Array.isArray(loginLogs) &&
                  loginLogs.map((log) => (
                    <tr key={log.id} className="logs-table-row">
                      <td className="logs-table-cell">{log.email}</td>
                      <td className="logs-table-cell">
                        {formatTime(log.login_time)}
                      </td>
                      <td className="logs-table-cell">
                        {" "}
                        {Number(log.status) === 1 ? "Success" : "Failed"}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        )}

        {view === "register" && (
          <div className="logs-section-horizontal">
            <h2 className="logs-title">Registration Logs</h2>
            <table className="logs-table">
              <thead className="logs-table-header">
                <tr>
                  <th className="logs-table-head">Email</th>
                  <th className="logs-table-head">Time</th>
                </tr>
              </thead>
              <tbody>
                {registerLogs.map((log) => (
                  <tr key={log.id} className="logs-table-row">
                    <td className="logs-table-cell">{log.Email}</td>
                    <td className="logs-table-cell">{formatTime(log.Time)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default Dashboard;
